import './head.scss'
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { AppContext, channel } from '@utils/AppContext';
import { Menu, Divider, message, Popover, Button, Modal } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import LoginModal from '../loginModal';
import LoggedHead from './loggedHead/loggedHead';
import LoginHead from './loginHead/loginHead';
import eventBus from '@utils/eventBus';
import Utils from '@utils/utils'
import styles from './head.module.scss'
import { HOME_PAGE_TYPE, IMAGE_TYPE } from "@utils/CONST"
import PSAIModal from '@PSAIComponents/PSAIModal';
import dayjs from 'dayjs';
import API from '@api/api';

const Head = (props) => {
    const location = useLocation();
    const navigate = useNavigate();

    const { globalHomePageType, globalActivity, updateGlobalHomePageType } = useContext(AppContext);
    const [loginOpen, setLoginOpen] = useState(false)
    const [mobile, setMobile] = useState()
    const [iconRotate, setIconRotate] = useState(0)
    const loginCallback = useRef()

    useEffect(() => {
        const handleLoginMessage = ({ mobile, callback } = {}) => {
            if (localStorage.getItem('token')) {
                message.info('您已登录')
            } else {
                setMobile(mobile)
                setLoginOpen(true)
            }
            if (callback) loginCallback.current = callback
        }

        eventBus.on('login', handleLoginMessage);

        return () => {
            eventBus.off('login', handleLoginMessage);
        }
    }, [])

    const loginClick = () => {
        setLoginOpen(true)
    }

    const type = useMemo(() => {
        if (globalHomePageType == HOME_PAGE_TYPE.MERCHANDISE) return 'AI商品图'
        else if (globalHomePageType == HOME_PAGE_TYPE.CLOTHING) return '服装模特图'
        else if (globalHomePageType == HOME_PAGE_TYPE.IMAGE_SERVICE) return "AI商拍服务"
    }, [globalHomePageType])

    const logoShowType = useMemo(() => { // 左上角logo显示品类
        return false
    }, [location.pathname])

    useEffect(() => {
        if (!loginOpen) setMobile('')
    }, [loginOpen])

    const goToAIEdit = (menuKey) => {
        updateGlobalHomePageType(HOME_PAGE_TYPE.CLOTHING)
        navigate("/home/aiEdit", { state: { menuKey: menuKey } })
    }

    const handleTitleClick = (type) => {
        console.log(type)
        if (type == HOME_PAGE_TYPE.CLOTHING) {
            Utils.useroplog(HOME_PAGE_TYPE.CLOTHING, 'function', 'navigation', { from: 'homeMenu' })
            Utils.clearClothesTaskCache()
            navigate("/home/homemain/clothes")
        } else if (type == HOME_PAGE_TYPE.MERCHANDISE) {
            Utils.useroplog(HOME_PAGE_TYPE.MERCHANDISE, 'function', 'navigation', { from: 'homeMenu' })
            Utils.clearMerchandiseTaskCache()
            navigate("/home/homemain/commodity")
        } else if (type == '/home/homemain/model_video') {
            navigate("/home/homemain/model_video")
        } else if (type == '/home/product/batchImages') {
            navigate("/home/product/batchImages")
        } else {
            goToAIEdit("magicErase")
        }
    }

    const menuChange = (e) => {
        // 避免在我的项目-批量生图处点击，头部导航我的项目
        const currentRoute = location.pathname;
        if (currentRoute == '/home/myProject/batchImages' && e.key == '/home/myProject/list') return
        const lastKey = e.keyPath[e.keyPath.length - 1]
        if (lastKey == HOME_PAGE_TYPE.CLOTHING) {
            Utils.useroplog(HOME_PAGE_TYPE.CLOTHING, 'function', 'navigation', { from: 'homeMenu' })
            Utils.clearClothesTaskCache()
            navigate(e.key)
        } else if (lastKey == HOME_PAGE_TYPE.MERCHANDISE) {
            Utils.useroplog(HOME_PAGE_TYPE.MERCHANDISE, 'function', 'navigation', { from: 'homeMenu' })
            Utils.clearMerchandiseTaskCache()
            navigate(e.key)
        } else if (lastKey == '/home/homemain/model_video') {
            Utils.useroplog(IMAGE_TYPE.MODEL_VIDEO, 'function', 'navigation', { from: 'homeMenu' })
            Utils.clearMerchandiseTaskCache()
            navigate(e.key)
        } else if (lastKey == IMAGE_TYPE.IMAGE_TO_VIDEO) {
            Utils.useroplog(IMAGE_TYPE.IMAGE_TO_VIDEO, 'function', 'navigation', { from: 'homeMenu' })
            Utils.clearMerchandiseTaskCache()
            navigate('/home/homemain/model_video_img')
        } else if (e.key == "/home/image_extraction") {
            window.open(e.key, '_blank')
        } else if (e.key == "/home/product/batchImages") {
            navigate(e.key)
        } else if (e.key == "/home/imageResize") {
            window.open(e.key, '_blank')
        } else if (e.key == "handRepair") {
            goToAIEdit("handRepair")
        } else if (e.key == "magicErase") {
            goToAIEdit("magicErase")
        } else if (e.key == "filllight") {
            goToAIEdit("filllight")
        } else if (e.key == "beautify") {
            goToAIEdit("beautify")
        } else if (e.key == "/service") {
            navigate(e.key)
        } else if (e.key == "/home/myProject/list") {
            const status = Utils.checkLoginStatus(() => navigate(e.key))
            if (!status) return
            navigate(e.key)
        } else if (e.key == "/home/material") {
            const status = Utils.checkLoginStatus(() => navigate(e.key))
            if (!status) return
            navigate(e.key)
        } else if (e.key == "/homePageMaster") {
            navigate(e.key)
        }
    }

    const selectedKeys = useMemo(() => {
        if (location.pathname == "/home/aiEdit") return ["AITOOL"]
        else return [location.pathname]
    }, [location])

    const items = [{
        key: "/homePageMaster",
        label: <p className={styles.NewTag}>成片交付服务</p>,
        onTitleClick: () => handleTitleClick('/homePageMaster')
    }, {
        key: HOME_PAGE_TYPE.CLOTHING,
        label: "AI商拍图",
        popupClassName: `${styles.MenuPopup} ${styles.MenuPopupTwoCols}`,
        popupOffset: [-66, 0],
        onTitleClick: () => handleTitleClick(HOME_PAGE_TYPE.CLOTHING),
        children: [{
            key: "/home/homemain/clothes",
            label: <p className={`${styles.MenuLable} ${styles.ChangeCloth}`}>AI试衣</p>
        }, {
            key: "/home/homemain/simTryon",
            label: <p className={`${styles.MenuLable} ${styles.ChangeSimTryon}`}>同版型试衣</p>
        }, {
            key: "/home/homemain/model",
            label: <p className={`${styles.MenuLable} ${styles.ChangeModel}`}>换模特</p>
        }, {
            key: "/home/homemain/background",
            label: <p className={`${styles.MenuLable} ${styles.ChangeBg}`}>换背景</p>
        }, {
            key: "/home/homemain/shoesTryon",
            label: <p className={`${styles.MenuLable} ${styles.ChangeShoes}`}>鞋子上脚</p>
        }, {
            key: "/home/homemain/glassesTryon",
            label: <p className={`${styles.MenuLable} ${styles.ChangeGlasses}`}>眼镜试戴</p>
        }, {
            key: "/home/homemain/poseTryon",
            label: <p className={`${styles.MenuLable} ${styles.ChangeFantasy}`}>姿势裂变</p>
        }, {
            key: "/home/homemain/clothRecolor",
            label: <p className={`${styles.MenuLable} ${styles.ChangeColorCloth}`}>服饰换色</p>
        }, {
            key: "/home/homemain/fusionWear",
            label: <p className={`${styles.MenuLable} ${styles.ChangeFusionWear}`}>搭配上身</p>
        }, {
            key: "/home/homemain/grassPlant",
            label: <p className={`${styles.MenuLable} ${styles.ChangeGrassPlant}`}>种草图</p>  // <span className={styles.newIcon}></span>
        }, {
            key: "/home/homemain/commodity",
            label: <p className={`${styles.MenuLable} ${styles.ChangeGoods}`}>商品换背</p>
        }, {
            key: "/home/homemain/commodityRecolor",
            label: <p className={`${styles.MenuLable} ${styles.ChangeColor}`}>商品换色</p>
        }, {
            key: "/home/homemain/watermarkRemove",
            label: <p className={`${styles.MenuLable} ${styles.ChangeWatermarkRemove}`}>去水印</p>
        }]
    },
    {
        key: '/home/homemain/model_video',
        label: "AI视频",
        popupClassName: styles.MenuPopup,
        popupOffset: [-66, 0],
        onTitleClick: () => handleTitleClick('/home/homemain/model_video'),
        children: [{
            key: "/home/homemain/model_video",
            label: <p className={`${styles.MenuLable} ${styles.ChangeTryonVideo}`}>动作模仿</p>
        }, {
            key: "/home/homemain/model_video_img",
            label: <p className={`${styles.MenuLable} ${styles.Changeimage2Video}`}>图生视频</p>
        }]
    }, {
        key: "AITOOL",
        label: <span className={styles.FreeLimitTag}>AI工具箱</span>,
        popupClassName: styles.MenuPopup,
        popupOffset: [-66, 0],
        onTitleClick: () => handleTitleClick("AITOOL"),
        children: [{
            key: "/home/image_extraction",
            label: <p className={`${styles.MenuLable} ${styles.Keying}`}>智能抠图</p>
        }, {
            key: "/home/imageResize",
            label: (
                <p className={`${styles.MenuLable} ${styles.Resize}`}>高清改尺寸</p>
            )
        }, {
            key: "handRepair",
            label: <p className={`${styles.MenuLable} ${styles.Hand}`}>手部修复</p>
        }, {
            key: "magicErase",
            label: <p className={`${styles.MenuLable} ${styles.Eraser}`}>魔法擦除</p>
        }, {
            key: "filllight",
            label: <p className={`${styles.MenuLable} ${styles.Relight}`}>智能补光</p>
        }]
    }, {
        key: '/home/product/batchImages',
        label: <span className={styles.batchImagesTag}>企业版 </span>,
        popupClassName: styles.MenuPopup,
        popupOffset: [-66, 0],
        onTitleClick: () => handleTitleClick('/home/product/batchImages')
    },
    {
        key: "/home/myProject/list",
        label: <p>我的项目</p>,
    },
    {
        key: "/home/material",
        label: <p>素材管理</p>,
    },
    {
        key: "/connect_us",
        // label: <a href="/connect_us">产品资讯</a>,
        label: <a href="/article" target="_blank">产品资讯</a>,
    }]

    const onOpenChange = (openKeys) => {
        if (openKeys.length > 0) {
            setIconRotate(180)
        } else {
            setIconRotate(0)
        }
    }

    const goBack = () => {
        navigate('/')
    }

    // 活动状态 0-未开始 1-进行中 2-已结束
    const ACTIVITY_240711_STATUS = useMemo(() => {
        if (!globalActivity) return 0
        const activity = globalActivity.ACTIVITY_240711
        // const now = dayjs('2024-07-14')
        const now = dayjs()
        const start = dayjs(activity.beginAt)
        const end = dayjs(activity.endAt)
        return now.isBefore(start) ? 0 : now.isAfter(end) ? 2 : 1
    })

    const loginCloseFunc = (logged, isRegister) => {
        setLoginOpen(false)
        if (logged) {
            Utils.clearAllTaskCache()
            if (isRegister) { // 首次登录
                if (ACTIVITY_240711_STATUS == 1) eventBus.emit('cashbackActivity') // 返现活动
                else eventBus.emit('inviteUser')
                eventBus.emit('rewardMessage', '首次登录赠送豆数', 300)
            } else {
                message.success('登录成功', 5)
            }
            const url = new URL(window.location.href)
            const orgId = url.searchParams.get('orgId')
            const key = url.searchParams.get('key')

            if (orgId && key) {
                eventBus.emit('OPEN_JOIN_TEAM')
            }
        }
        if (loginCallback.current) {
            if (!!logged) { // 登录成功
                API.userInfo({}).then((res) => {
                    if (res.code == 0) {
                        if (!res.data?.downloadNoLogo) {
                            // setWaterOpen(true)
                        } else {
                            loginCallback.current(true)
                            loginCallback.current = null
                        }
                    }
                })
            } else { // 登录失败/取消
                loginCallback.current(!!logged)
                loginCallback.current = null
            }
        } else {
            if (!!logged) { // 登录成功
                API.userInfo({}).then((res) => {
                    if (res.code == 0) {
                        if (!res.data?.downloadNoLogo) {
                            // setWaterOpen(true)
                        } else {
                            const urlParams = new URLSearchParams(location.search)
                            const redirect = urlParams.get('redirect')
                            if (redirect) navigate(redirect)
                        }
                    }
                })
            }
        }
    }

    const isImageExtraction = useMemo(() => {
        return location.pathname == '/home/image_extraction'
    }, [location])

    const isImageResize = useMemo(() => {
        return location.pathname == '/home/imageResize'
    }, [location])

    const noBackground = useMemo(() => {
        return props.noBackground || location.pathname == '/'
    }, [props.noBackground, location.pathname])

    return (
        <>
            <div className='Head LoginHead'
                style={{
                    backgroundColor: noBackground ? 'transparent' : '#FFFFFF',
                    borderBottom: noBackground ? 'none' : '1px solid var(--gray-light)'
                }}>
                <div className="head_left">
                    {
                        isImageExtraction || isImageResize ?
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '16px', fontWeight: 700, whiteSpace: 'nowrap' }}>
                                <i className='logo2' onClick={goBack}></i>
                                <span style={{ position: "relative", top: 2 }}>{isImageExtraction ? '智能抠图' : '高清改尺寸'}</span>
                            </div> :
                            <>
                                {
                                    logoShowType ?
                                        <>
                                            {type == '服装模特图' && <i className='logo2 cloth_logo' onClick={goBack}></i>}
                                            {type == 'AI商品图' && <i className='logo2 mc_logo' onClick={goBack}></i>}
                                            {type == 'AI商拍服务' && <i className='logo2' onClick={goBack}></i>}
                                        </> :
                                        <i className='logo2' onClick={goBack}></i>
                                }
                            </>
                    }
                </div>
                <div className="head_center">
                    <Menu
                        className={styles.HeadMenu}
                        style={{
                            '--head-menu-color': noBackground ? '#000' : '#4a5565',
                            '--head-menu-hover-color': location.pathname == '/' ? '#4a5565' : '#006EFF'
                        }}
                        key={location.pathname}
                        selectedKeys={selectedKeys}
                        mode="horizontal"
                        overflowedIndicator={<EllipsisOutlined />}
                        items={items}
                        onClick={menuChange}
                        onOpenChange={onOpenChange}
                    />
                </div>
                <div className="head_right">
                    {
                        localStorage.getItem('token') ?
                            <LoggedHead /> :
                            <LoginHead onLogin={loginClick} />
                    }
                </div>
            </div>
            <PSAIModal
                maxWidth={820}
                open={loginOpen}
                footer={null}
                closable={false}
                onCancel={() => loginCloseFunc(false)}
            >
                <LoginModal open={loginOpen} mobile={mobile} closeFunc={loginCloseFunc} />
            </PSAIModal>
        </>
    );
};

export default Head;
